"use client";

import { ChevronDown } from "lucide-react";
import { useState } from "react";

interface SelectOption {
  label: string;
  value: string | number;
}

interface SelectInputProps {
  options: SelectOption[];
  value: string | number;
  onChange: (val: any) => void;
  label?: string;
  id?: string;
}

export default function SelectInput({
  options,
  value,
  onChange,
  label,
  id,
}: SelectInputProps) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="select-input-wrapper">
      {label && <label htmlFor={id} className="input-label">{label}</label>}
      <div className={`select-container ${isFocused ? 'focused' : ''}`}>
        <select
          id={id}
          className="select-field"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <div className="select-icon">
          <ChevronDown size={18} strokeWidth={2.5} />
        </div>
      </div>

      <style jsx>{`
        .select-input-wrapper {
          width: 100%;
          margin-bottom: 0;
        }
        .select-container {
          position: relative;
          display: flex;
          align-items: stretch;
          background-color: var(--bg-input);
          border: 1px solid var(--border-color);
          border-radius: var(--radius-md);
          overflow: hidden;
          transition: all var(--transition-fast);
          height: 3rem;
        }

        .select-container.focused {
          border-color: var(--primary);
          box-shadow: 0 0 0 3px var(--primary-light);
        }
        .select-field {
          flex: 1;
          border: none;
          background: transparent;
          color: var(--text-primary);
          font-family: var(--font-body);
          font-size: var(--text-base);
          font-weight: var(--fw-bold);
          padding: 0 1.25rem;
          padding-right: 3rem;
          outline: none;
          cursor: pointer;
          text-align: left;
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
        }
        .select-field::-ms-expand {
          display: none;
        }
        .select-field option {
          background-color: var(--bg-surface);
          color: var(--text-primary);
          padding: var(--space-2);
        }
        .select-icon {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: var(--text-muted);
          pointer-events: none;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </div>
  );
}
